import { gql } from '@apollo/client';

export const GET_USER_FAVORITES = gql`
  query GetUserFavorites {
    userFavorites {
      id
      itemId
      itemType
      itemDetails {
        ... on PSA {
          title
          description
          imageUrl
        }
        ... on LostAnimal {
          animalName
          lastSeen
          breed
          colorMarkings
          animalImageUrl
        }
        ... on FoundAnimal {
          animalName
          foundNear
          breed
          colorMarkings
          animalImageUrl
        }
        ... on Place {
          name
          address
          website
          phone
        }
        ... on PetService {
          title
          description
          imageUrl
        }
      }
    }
  }
`;

export const GET_FAVORITE_DETAILS = gql`
  query GetFavoriteDetails($itemId: String!) {
    favorite(itemId: $itemId) {
      id
      itemId
      itemType
      itemDetails {
        ... on Place {
          name
          address
          website
          phone
        }
        ... on PSA {
          title
          description
          imageUrl
          createdAt
        }
        ... on LostAnimal {
          contactName
          contactPhone
          contactEmail
          location {
              type
              coordinates
          }
          animalName
          animalType
          animalImageUrl
          breed
          colorMarkings
          dateLost
          sex
          lastSeen
          rewardAmount
          createdAt
        }
        ... on FoundAnimal {
          animalName
          contactName
          contactPhone
          contactEmail
          location {
              type
              coordinates
          }
          animalType
          animalImageUrl
          breed
          colorMarkings
          dateFound
          sex
          foundNear
          createdAt
        }
        ... on PetService {
          title
          description
          imageUrl
          createdAt
        }
      }
    }
  }
`;